<template lang="html">
  <div class="container">
    <div class="row">
        <!-- {{improvements}} -->
        <div v-if="count!=1">{{count}} améliorations en attente de validation</div>
        <div v-else>{{count}} amélioration en attente de validation</div>
        <div class="col s12">
            <table class="responsive-table highlight">
                <thead>
                    <tr>
                        <!-- <th>Statut</th> -->
                        <th>Ref</th>
                        <th>Création</th>
                        <th>Utilisateur</th>
                        <th>Objet</th>
                        <!-- <th>Situation</th> -->
                        <th>Proposition</th>
                        <!-- <th>Etat visuel</th> -->
                        <th>Valider</th>
                        <th>Annuler</th>
                        <th>Consulter</th>

                    </tr>
                </thead>
                <tbody>
                    <tr v-for="improvement in improvements">
                        <!-- <td class="" v-bind:class="{'cyan accent-4': improvement.state=='ouverte',
                                                'orange lighten-2': improvement.state=='en cours',
                                                'green accent-3': improvement.state=='déclarée' }"
                        >{{improvement.state}}</td> -->
                        <td>{{improvement.ref | ref}}</td>
                        <td>{{improvement.created_at | formatDate}}</td>
                        <td>{{improvement.user}}</td>
                        <td>{{improvement.object}}</td>
                        <!-- <td>{{improvement.situation}}</td> -->
                        <td>{{improvement.proposal | shorten}}</td>
                        <!-- <td>{{improvement.visual_state}}</td> -->
                        <td><a @click.prevent="validate(improvement.id)"><i class="material-icons green-text">check</i></a></td>
                        <td><a @click.prevent="cancel(improvement.id)"><i class="material-icons red-text">clear</i></a> </td>
                        <td><router-link :to="{ name: 'EditImprovement', params: {ref: improvement.ref} }">
                            <i class="material-icons edit">remove_red_eye</i>
                        </router-link></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
  </div>
</template>

<script>
import db from '@/firebase/init'
import moment from 'moment'
import 'moment/locale/fr'

export default {
    name: 'NewImprovements',
    data(){
        return{
            improvements: [],
            count: ''
        }
    },
    filters: {
        formatDate: function(value) {
            if (value) {
                return moment(value).locale('fr').format('L')
            }
        }
    },
    methods:{
            validate(imp){
                db.collection('improvements').doc(imp).update({
                    state: 'ouverte'
                })
                .then(() =>{
                    let index = this.improvements.findIndex(x => x.id === imp)
//console.log(index);
                    this.improvements.splice(index, 1)
                    this.count = this.improvements.length
                })
            },
            cancel(imp){
                db.collection('improvements').doc(imp).update({
                    state: 'annulée'
                })
                .then(() =>{
                    let index = this.improvements.findIndex(x => x.id === imp)
//console.log(index);
                    this.improvements.splice(index, 1)
                    this.count = this.improvements.length
                })
            }
    },
    created(){
        // get unvalidated improvements
        let ref = db.collection('improvements')
        ref.where('state', '==', 'déclarée').orderBy('created_at').get()
        .then(snapshot => {
            snapshot.forEach(doc => {
                let improvement = doc.data()
                improvement.id = doc.id
                this.improvements.push(improvement)
            })
        }).then(() => {
            this.count = this.improvements.length
        }).then(() => {
            this.improvements.reverse()
        })
    }
}
</script>

<style lang="css" scoped>
td a {
    cursor: pointer;
}
</style>
